import { render, staticRenderFns } from "./PageTemp.vue?vue&type=template&id=2a76783c&"
import script from "./PageTemp.vue?vue&type=script&lang=js&"
export * from "./PageTemp.vue?vue&type=script&lang=js&"
import style0 from "./PageTemp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports